import '@angular/compiler';
import { NgModule, Injector } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HashLocationStrategy, PathLocationStrategy, LocationStrategy, PlatformLocation, APP_BASE_HREF } from '@angular/common';
import { RoomReservationComponent } from '../room-reservation/room-reservation.component';
import { MyReservationComponent } from '../room-reservation/components/my-reservation/my-reservation.component';
import { PageNotFoundComponent } from 'src/app/shared/components/page-not-found/page-not-found.component';
import { LogoutComponent } from 'src/app/shared/components/logout/logout.component';
import { DeviceReservationComponent } from '../room-reservation/device-reservation.component';
import { StartPageComponent } from '../room-reservation/components/start-page/start-page.component';
import { IAppConfig } from 'src/app/shared/services/app-config.service';

const routes: Routes = [
  {
    path: '',
    component: StartPageComponent
  },
  // Räume suchen
  {
    path: 'rooms',
    component: RoomReservationComponent
  },
  {
    path: 'devices',
    component: DeviceReservationComponent
  },
  {
    path: 'my',
    component: MyReservationComponent,
    children: [{
      path: 'confirmation/:id',
      component: MyReservationComponent,
    }]
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  providers: [
    {
      provide: LocationStrategy,
      deps: [Injector],
      useFactory: (inj: Injector) => {
        return (((window as any)._RoomReservationConfig || {}) as IAppConfig).useHashRouting || false
          ? new HashLocationStrategy(inj.get(PlatformLocation))
          : new PathLocationStrategy(inj.get(PlatformLocation))
      }
    }
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
